export enum FilterType {
  Text = 'text',
  Number = 'number',
  Set = 'set',
  DateTime = 'datetime',
  Date = 'date',
  Time = 'time',
}

export type FiltersWithoutSet = Exclude<FilterType, FilterType.Set>
export type AllFilterTypes = FilterType

//Filters modeled after back-end https://stash.arbfund.com/projects/HEL/repos/helios/browse/libs/request-model/src/main/kotlin/com/clearwateranalytics/helios/requests/filter
export interface Filter {
  filterType: AllFilterTypes
}

/*
These types of filters can have multiple filters.
Example Text filter with `contains A` & `startsWith X`
 */
export interface MultiFilter<T> extends Filter {
  operator: 'OR' | 'AND'
  filterType: FiltersWithoutSet
  filters: SingleFilter<T>[]
}

export interface SingleFilter<T> {
  operator: string
  value?: T
  values?: T[]
}
